module.exports = __webpack_public_path__ + "static/media/aguaMicelar.76aba694.png";